/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Use_4_ValueInputs */

const en_svc_n8n_use_4_value = /** @type {(inputs: Svc_N8n_Use_4_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When one team finishes, the next gets the task with its context attached.`)
};

const lv_svc_n8n_use_4_value = /** @type {(inputs: Svc_N8n_Use_4_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kad viena komanda pabeidz, nākamā saņem uzdevumu kopā ar kontekstu.`)
};

/**
* | output |
* | --- |
* | "When one team finishes, the next gets the task with its context attached." |
*
* @param {Svc_N8n_Use_4_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_use_4_value = /** @type {((inputs?: Svc_N8n_Use_4_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Use_4_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_use_4_value(inputs)
	return en_svc_n8n_use_4_value(inputs)
});